export const BASE_ROUTE = 'ws1/user-gateway';
export const USER_PROFILE_BASE_ROUTE = BASE_ROUTE + '/user-profile';
export const ORGANIZATION_API_BASE_ROUTE = BASE_ROUTE + '/organization';
export const BI_ANALYTICS_API_BASE_ROUTE = BASE_ROUTE + '/bi-analytics';
export const MARKETING_API_BASE_ROUTE = BASE_ROUTE + '/marketing';
export var AccountStages;
(function (AccountStages) {
    AccountStages["expired"] = "EXPIRED";
    AccountStages["grace"] = "GRACE";
    AccountStages["active"] = "ACTIVE";
    AccountStages["soloPro"] = "pro";
    AccountStages["soloFree"] = "free";
    AccountStages["trialActive"] = "TRIAL-ACTIVE";
    AccountStages["trialExpired"] = "TRIAL-EXPIRED";
})(AccountStages || (AccountStages = {}));
export var ResponseErrors;
(function (ResponseErrors) {
    ResponseErrors["GATEWAY_ERROR_MISSING_AUTH_DATA"] = "accountId or userId are missing";
    ResponseErrors["GATEWAY_ERROR_MISSING_REQUIRED_DATA"] = "required data is missing";
    ResponseErrors["GATEWAY_ERROR_INVALID_ACCOUNT_STATE_FOR_ONBOARDING"] = "invalid account state for onboarding";
    ResponseErrors["GATEWAY_ERROR_FAILED_TO_CREATE_BILLING_ACCOUNT"] = "failed to create billing account";
    ResponseErrors["GATEWAY_ERROR_FAILED_TO_CREATE_SUBSCRIPTION"] = "failed to create subscription";
    ResponseErrors["GATEWAY_ERROR_SET_WORKSPACE_FAILED"] = "set workspace failed";
    ResponseErrors["BRIDGE_SERVER_ERROR_UPDATE_BASIC_INFO"] = "update basic info bridge error";
    ResponseErrors["BRIDGE_SERVER_ERROR_SET_ACCOUNT_TYPE"] = "set account type bridge error";
    ResponseErrors["BRIDGE_SERVER_ERROR_COMPLETE_SETUP"] = "complete setup bridge error";
    ResponseErrors["BRIDGE_SERVER_ERROR_REMOVE_ORGANIZATION"] = "remove organization bridge error";
    ResponseErrors["ORGANIZATION_COUNT_ERROR_REMOVE_ORGANIZATION"] = "remove organization count of organization less then two";
    ResponseErrors["BRIDGE_SERVER_ERROR_COMPLETE_SETUP_STAGE"] = "complete setup stage bridge error";
    ResponseErrors["SERVER_ERROR_CREATE_ORGANIZATION"] = "create organization error";
    ResponseErrors["LIMIT_ERROR_CREATE_ORGANIZATION"] = "create organization limit error";
    ResponseErrors["ORGANIZATION_NAME_ALREADY_EXISTS"] = "organization name already exists";
    ResponseErrors["SERVER_ERROR_SET_DEFAULT_ORGANIZATION"] = "set default organization error";
    ResponseErrors["GATEWAY_ERROR_USER_NOT_FOUND"] = "user not found";
})(ResponseErrors || (ResponseErrors = {}));
export const ACCOUNT_MANAGE_PERMISSION = 'account.manage';
export const ACCOUNT_BILLING_PERMISSION = 'account.billing';
export const DOMAIN_EDIT_PERMISSION = 'domain.edit';
export const ENT_EMPLOYEE_FIELDS = 'employee-fields';
export const ENT_COMPANY_FIELDS = 'company-fields';
//# sourceMappingURL=consts.js.map